export default __webpack_public_path__ + "static/media/aapi.d69ff781.png";